import { render } from "./OrderStatisticsComponent.vue?vue&type=template&id=8463be9c"
import script from "./OrderStatisticsComponent.vue?vue&type=script&lang=js"
export * from "./OrderStatisticsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/dashboard/OrderStatisticsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8463be9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8463be9c', __exports__)) {
    api.reload('8463be9c', __exports__)
  }
  
  module.hot.accept("./OrderStatisticsComponent.vue?vue&type=template&id=8463be9c", () => {
    api.rerender('8463be9c', render)
  })

}


export default __exports__